import { Injectable } from '@angular/core';
import { ITextLabel } from '@fi-app/fi-translation/fi-translation';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { FiImageSize, FileType } from '@fi-shared/types';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';

@Injectable()
export class FiTranslationService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private formatDateService: FiFormatDateService,
        private fiPrintDownloadService: FiPrintDownloadService,
    ) {}

    getTextLabels() {
        return this.fiBackend.fetchData<ITextLabel[]>('Localization/ApplicationLanguageLabel/GetTextLabels');
    }

    saveTextLabel(textLabel: ITextLabel) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<ITextLabel>('Localization/ApplicationLanguageLabel/SaveTextLabel', textLabel),
        );
    }

    deleteTextLabel(textLabel: ITextLabel) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>('Localization/ApplicationLanguageLabel/DeleteTextLabel', textLabel),
        );
    }

    invalidateApplicationLanguageLabelsCache() {
        return this.fiBackend.fetchData<void>(
            'Localization/ApplicationLanguageLabel/InvalidateApplicationLanguageLabelsCache',
        );
    }

    downloadTextLabelsExcel() {
        const url = `Localization/ApplicationLanguageLabel/GetTextLabelsExcel`;
        const fileName = this.fiPrintDownloadService.getReportFileName('labels', FileType.Excel);

        const promise = this.fiPrintDownloadService.downloadBinaryFile(url, {
            fileName: fileName,
            size: FiImageSize.Original,
            getMethod: true,
        });
        return promise;
    }

    copyTextLabels(sourceGlobalDatabase: string, targetGlobalDatabase: string) {
        const url = `Localization/ApplicationLanguageLabel/CopyTextLabels?source=${sourceGlobalDatabase}&target=${targetGlobalDatabase}`;
        return this.fiBackend.fetchDataPost<void>(url);
    }

    importTextLabelsFromExcel(formFile: File, textIdsToKeep: string, textIdsToOverwrite: string) {
        const fd = new FormData();
        fd.append('formFile', formFile);
        fd.append('textIdsToKeep', textIdsToKeep || '');
        fd.append('textIdsToOverwrite', textIdsToOverwrite || '');
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<any>('Localization/ApplicationLanguageLabel/ImportTextLabelsFromExcel', fd),
        );
    }
}
